import { AnalyticsDirectivesModule } from '@analytics/events';
import type { ToolTrackValues } from '@analytics/models';
import { Component, input, output } from '@angular/core';
import type {
  HomeBatteryOrderForm,
  HomeBatteryOrderFormRendering,
} from '@feh/homebattery-models';
import type { HomeBatteryAdviceFormSubmitState } from '@feh/homebattery-store';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { ReactiveFormsAbstractionsModule } from '@innogy/feh/rfa';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-homebattery-order-form-ui',
  standalone: true,
  imports: [
    CommonUiFormsModule,
    ReactiveFormsAbstractionsModule,
    FontAwesomeModule,
    AnalyticsDirectivesModule,
    ScFieldValuePipe,
    AutomationIdDirective,
  ],
  templateUrl: './homebattery-order-form-ui.component.html',
  styleUrls: [
    './homebattery-order-form-ui.component.ed.scss',
    './homebattery-order-form-ui.component.essent.scss',
  ],
})
export class HomebatteryOrderFormUiComponent {
  public readonly rendering = input.required<HomeBatteryOrderFormRendering>();
  public readonly form = input.required<HomeBatteryOrderForm>();
  public readonly submitState =
    input.required<HomeBatteryAdviceFormSubmitState>();
  public readonly trackStep = input.required<ToolTrackValues>();

  public readonly formSubmit = output<void>();
}
